function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function shuffleArray(array) {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
}

function pluralize(n,one,few,many){
  var d = parseInt(n.toString().substr(-1));
  if(n > 10 && n < 20) return many;
  if(d == 1)           return one;
  if(d >= 2 && d <= 4) return few;
  /*otherwise*/        return many;
}

module.exports = {
  guid,
  getRandomInt,
  shuffleArray,
  pluralize,
};



/** WEBPACK FOOTER **
 ** ./src/shared/utils.js
 **/